import React from 'react';
import { Modal } from '../components';

const entries = counts => Object.entries(counts || {}).filter(([, count]) => count > 0)
  .sort(([a, x], [b, y]) => y - x || a.localeCompare(b, 'zh-CN'));

export function MerchantStatusSummary({ merchant, doneStatuses, onStatus, onAll }) {
  const statuses = entries(merchant.status_counts);
  const pending = statuses.filter(([name]) => !doneStatuses.includes(name)).slice(0, 3);
  return <div className="ka-merchant-status-counts">
    {pending.map(([name, count]) => <button key={name} type="button" className="ka-status-count" title={name} aria-label={`${merchant.name} · ${name}：${count} 单`} onClick={() => onStatus(name)}><span>{name}</span><strong>{count}</strong></button>)}
    {!pending.length && <span className="ka-muted">无未完成工单</span>}
    <button type="button" className="ka-link ka-all-statuses" onClick={onAll} aria-label={`${merchant.name} · 全部状态`}>全部状态（{statuses.length}）</button>
  </div>;
}

export function MerchantAllStatuses({ selection, onClose, onStatus }) {
  const statuses = entries(selection.merchant.status_counts);
  return <Modal isOpen title={`${selection.merchant.name} · 全部状态`} onClose={onClose} size="medium">
    <div className="ka-table-scroll ka-bounded-table">
      {statuses.length ? <table className="ka-all-statuses-table"><thead><tr><th>状态</th><th>工单数</th></tr></thead><tbody>{statuses.map(([name, count]) => <tr key={name}>
        <td><button type="button" className="ka-link" onClick={() => onStatus(name)}>{name}</button></td>
        <td><button type="button" className="ka-link" aria-label={`${name}：${count} 单`} onClick={() => onStatus(name)}><strong>{count} 单</strong></button></td>
      </tr>)}</tbody></table> : <p className="ka-muted">暂无工单</p>}
    </div>
  </Modal>;
}
